import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EntityCrudState } from '@homeleite/common-components';
import { Producer } from '@homeleite/domain';
import { debounceTime, distinctUntilChanged, map } from 'rxjs';

@Component({
    selector: 'homeleite-producer-details-form',
    templateUrl: './producer-details-form.component.html',
    styleUrls: ['./producer-details-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProducerDetailsFormComponent implements OnInit {
    public entity: Producer;

    state: EntityCrudState = EntityCrudState.VIEW;

    @Output() producerChange = new EventEmitter<Producer>();

    form: FormGroup;

    constructor(private fb: FormBuilder, private ref: ChangeDetectorRef) {}

    ngOnInit(): void {

    }

    get producer(): Producer {
        return this.entity;
    }

    @Input()
    set producer(producer: Producer) {
        if (producer !== this.entity) {
            this.entity = producer;
            this.createFormFromEntity();
            this.ref.markForCheck();
        }
    }

    onSubmit() {
        alert(JSON.stringify(this.entity));
    }

    contactLabel(category: string | null | undefined): string {
        const c = (category || '').toLowerCase();
        if (c.includes('mail') || c.includes('email')) return 'E-mail';
        if (c.includes('phone') || c.includes('fone') || c.includes('celular')) return 'Telefone';
        return category || 'Contato';
    }

    get formattedAddresses(): string[][] {
        const list = this.producer?.addresses || [];
        return list
            .map((address) => {
                const city = [address?.city?.name, address?.city?.state?.acronym]
                    .filter((p) => p && String(p).trim() && String(p).trim() !== '-')
                    .join(' — ');
                const street = [address?.street, address?.number]
                    .filter((p) => p && String(p).trim() && String(p).trim() !== '-')
                    .join(', ');
                const district = address?.district && String(address.district).trim() !== '-'
                    ? String(address.district).trim()
                    : '';
                const line2 = [street, district].filter(Boolean).join(' · ');
                return [city, line2].filter(Boolean);
            })
            .filter((lines) => lines.length > 0);
    }

    createFormFromEntity() {
        this.form = this.fb.group({});
        this.syncFromState();
    }

    private syncFromState() {
        if (this.form) {
            if (this.state === EntityCrudState.INSERT || this.state === EntityCrudState.EDIT) {
                this.form.enable();
            } else {
                this.form.disable();
            }
        }
    }

    private addFormValueChange(mapper: (f: any) => Producer) {
        this.form.valueChanges
            .pipe(distinctUntilChanged(), debounceTime(300), map(mapper))
            .subscribe((value) => {
                this.producerChange.emit((this.entity = value));
            });
    }
}
